const state = {
    tasks: [],
    numberOfTodoTasks: null,
    notes: [],
    numberOfnotes: null,
    doneTasks: [],
    inprogressTasks: [],
    todoTasks: [],
    ownTasks: []

};

const mutations = {
    SET_TASKS(state, tasks) {
        state.tasks = tasks;
    },
    SET_NUMBER_OF_TODO_TASKS(state, number) {
        state.numberOfTodoTasks = number;
    },
    SET_NOTES(state, notes) {
        state.notes = notes
    },
    SET_NUMBER_OF_PROFILE_NOTES(state, number) {
        state.numberOfnotes = number;
    },
    SET_DONE_TASKS(state, tasks) {
        state.doneTasks = tasks
    },
    SET_INPROGRESS_TASKS(state, tasks) {
        state.inprogressTasks = tasks
    },
    SET_TODO_TASKS(state, tasks) {
        state.todoTasks = tasks
    },
    SET_OWN_TASKS(state, tasks) {
        state.ownTasks = tasks
    }

};

const getters = {
    getTasks: (state) => {
        return state.tasks;
    },
    getNumberOfTodoTasks: (state) => {
        return state.numberOfTodoTasks;
    },
    getProfileNotes: (state) => {
        return state.notes;
    },
    getDoneTasks: state => {
        return state.doneTasks
    },
    getInprogressTasks: state => {
        return state.inprogressTasks
    },
    getTodoTasks: state => {
        return state.todoTasks
    },
    getOwnTasks: state => {
        return state.ownTasks;
    }


};

export default {
    state,
    mutations,
    getters,
};
